
import { MarkerType } from "../../types/map";

// Светлая тема
import camLight from "../../components/icons/markers/light/cam.png";
import cleanLight1 from "../../components/icons/markers/light/clean1.png";
import cleanLight2 from "../../components/icons/markers/light/clean2.png";
import cleanLight3 from "../../components/icons/markers/light/clean3.png";
import dpsLight1 from "../../components/icons/markers/light/dps1.png";
import dpsLight2 from "../../components/icons/markers/light/dps2.png";
import dpsLight3 from "../../components/icons/markers/light/dps3.png";
import dtpLight1 from "../../components/icons/markers/light/dtp1.png";
import dtpLight2 from "../../components/icons/markers/light/dtp2.png";
import dtpLight3 from "../../components/icons/markers/light/dtp3.png";

// Темная тема
import camDark from "../../components/icons/markers/dark/cam.png";
import cleanDark1 from "../../components/icons/markers/dark/clean1.png";
import cleanDark2 from "../../components/icons/markers/dark/clean2.png";
import cleanDark3 from "../../components/icons/markers/dark/clean3.png";
import dpsDark1 from "../../components/icons/markers/dark/dps1.png";
import dpsDark2 from "../../components/icons/markers/dark/dps2.png";
import dpsDark3 from "../../components/icons/markers/dark/dps3.png";
import dtpDark1 from "../../components/icons/markers/dark/dtp1.png";
import dtpDark2 from "../../components/icons/markers/dark/dtp2.png";
import dtpDark3 from "../../components/icons/markers/dark/dtp3.png";

const lightIcons = {
    dps: { type0: dpsLight1, type1: dpsLight2, type2: dpsLight3 },
    clean: { type0: cleanLight1, type1: cleanLight2, type2: cleanLight3 },
    dtp: { type0: dtpLight1, type1: dtpLight2, type2: dtpLight3 },
    webcam: { type0: camLight, type1: camLight, type2: camLight },
};

const darkIcons = {
    dps: { type0: dpsDark1, type1: dpsDark2, type2: dpsDark3 },
    clean: { type0: cleanDark1, type1: cleanDark2, type2: cleanDark3 },
    dtp: { type0: dtpDark1, type1: dtpDark2, type2: dtpDark3 },
    webcam: { type0: camDark, type1: camDark, type2: camDark },
};

// Кеш иконок для оптимизации производительности
const iconCache = new Map<string, string>();

export const createMarkerIcon = (
    markerType: MarkerType,
    locationType: 0 | 1 | 2 = 0,
    theme: "light" | "dark" = "light"
): string => {
    // Создаем уникальный ключ для кеша
    const cacheKey = `${markerType}-${locationType}-${theme}`;

    // Проверяем кеш
    const cached = iconCache.get(cacheKey);
    if (cached) {
        return cached;
    }

    // Вычисляем иконку
    const icons = theme === "dark" ? darkIcons : lightIcons;
    const iconKey = `type${locationType}` as 'type0' | 'type1' | 'type2';
    const icon = icons[markerType][iconKey];

    // Сохраняем в кеш
    iconCache.set(cacheKey, icon);

    return icon;
};

export const MARKER_SIZES = {
    normal: [46, 51] as [number, number],
    selected: [60, 66] as [number, number],
};

export const MARKER_ANCHORS = {
    normal: [23, 51] as [number, number],
    selected: [30, 66] as [number, number],
};